import SwitchSystem from './SwitchSystem';
import './SwitchSystem.scss';

export default SwitchSystem;
